import { render, staticRenderFns } from "./OxygenBorderInput.vue?vue&type=template&id=69b7ef46&"
import script from "./OxygenBorderInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenBorderInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports